// src/modules/app-views/goodsReceipt/pages/Init/actions/menuButton.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { ClearOutlined, FileAddOutlined } from '@ant-design/icons';
import { dropdownParameters, dropdownDivider } from 'layouts/Pages/PageHeader/dropdownMenus';
import showNfeImportModal from '../modals/NfeImportModal';

// *******************************************************************************
// MENU BUTTON
// *******************************************************************************
const goodsReceiptInitMenuButton = () => {
  return {
    action: 'dropdownMenu',
    dropdownItems: [
      {
        key: 'importDocument',
        label: 'import_fiscal_document',
        icon: <FileAddOutlined />,
        onClick: ({ refresh }) => {
          showNfeImportModal({
            onSuccess: () => {
              // Refresh the list to show the new imported document
              if (typeof refresh === 'function') refresh();
            },
          });
        },
      },
      dropdownDivider,
      {
        key: 'clearFilters',
        label: 'clear_filters',
        icon: <ClearOutlined />,
        onClick: ({ clearFilters }) => {
          if (typeof clearFilters === 'function') {
            clearFilters();
          }
        },
      },
      'divider',
      dropdownParameters,
    ],
  };
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default goodsReceiptInitMenuButton;
